<template>
  <div class="cap-nav">
    <div class="d-flex justify-content-between align-items-center">
      <!-- .col -->
      <router-link id="logo" tag="div" :to="{ name: 'judging-entries' }">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 440.4 119.7"
          style="enable-background:new 0 0 440.4 119.7;"
          xml:space="preserve"
        >
          <g>
            <path
              d="M30.8,40.7c0.7,3.8,2,7.3,2.8,11h8.4c0.2-3.2-1.2-5.7-3.4-7.8C36.5,41.8,34,40.6,30.8,40.7 M32.8,77.6
		c2.8-0.2,4.9-1.7,6.5-3.6c1.7-2.2,3.1-4.6,2.5-7.4h-7.9c-0.6,1.6-1.3,3.1-3.4,3C31.4,72.2,32.1,74.8,32.8,77.6 M82,55.2
		c0.4,1.4,0.7,2.8,1.1,4.1c0.4,1.1,0.5,2.3,1.1,3.5c0.2,0.5,0.5,0.6,0.7,0.5c2.5-0.8,4.7-2.2,6.3-4.4c1.6-2.3,2.4-4.7,2.2-7.3
		c-0.1-1.3-0.4-2.5-1-3.8c-0.7-1.6-1.8-2.8-2.9-4c-1.1-1.1-2.3-1.9-3.8-2.3c-1.2-0.2-2.4-0.8-3.7-0.4c0.1,0.5,0.4,0.7,0.5,1.1
		c0.5,1.7,0.8,3.4,1.2,5c0.4,1.4,1,2.9,1.3,4.4c0.1,0.6,0.1,1.3-0.2,2C84.2,54.6,83.2,55,82,55.2 M54,40.7c0.2,0.4,0.4,0.5,0.4,0.7
		c0,1,0,1.9,0.4,2.8c0.2,0.7,0.2,1.4,0.4,2.3c0.1,0.8,0.1,1.6,0.4,2.4c0.4,1.6,0.5,3.2,0.7,4.8c0.2,1.6,0.5,3.2,0.7,4.8
		c0.1,0.7,0.1,1.4,0.4,2.3c0.2,0.7,0.2,1.6,0.4,2.4c0.4,1.6,0.5,3.2,0.7,4.8c0.1,0.8,0.2,1.6,0.4,2.4c0.1,0.8,0.1,1.6,0.4,2.4
		c0.1,0.7,0.4,1.6,0.4,2.4c0,1,0.4,1.7,0.6,2.6c2.6,0,5.4,0,8,0c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.2c-0.1-0.2-0.4-0.6-0.4-0.8
		c0.1-2.2-0.8-4.2-0.7-6.3c0-0.1,0-0.4-0.1-0.5c-0.5-0.5-0.1-1.1-0.2-1.6c-0.1-0.6-0.2-1.1-0.4-1.7c-0.1-1.2-0.1-2.4-0.4-3.5
		c-0.4-1.4-0.4-3-0.7-4.4c-0.2-1-0.1-2-0.4-3c-0.2-0.7-0.1-1.4-0.4-2c-0.2-0.6-0.2-1.3-0.2-2.2c0-0.2,0.1-0.5,0-0.5
		c-0.7-0.6-0.1-1.4-0.4-2c-0.4-0.7-0.4-1.3-0.4-2c0-0.2,0.1-0.6,0-0.7c-0.6-0.6-0.1-1.3-0.4-1.9c-0.4-0.7-0.4-1.3-0.4-2
		c0-1.3-0.1-1.4-1.6-1.4C59,40.7,56.6,40.7,54,40.7 M65.1,11.6c0,0.1,0.1,0.2,0.1,0.4c0.6,0,1.1,0,1.7,0.1c0.5,0.1,1,0.2,1.6,0.4
		c2.9,0.6,5.7,1.3,8.6,2.4c2.2,0.8,4.1,1.9,6.1,2.9c1.9,1,3.6,2,5.3,3.4c1.9,1.6,4,3,5.6,4.9c1.6,1.7,2.9,3.6,4.3,5.4
		c2.4,3,4,6.3,5.5,9.7c1,2.2,1.7,4.3,2.2,6.6c0.4,1.3,0.4,2.8,1.1,4c-0.2,1.3,0.4,2.5,0.4,3.7c0,2.8,0,5.5,0,8.3
		c0,0.7-0.2,1.3-0.4,2c-0.1,0.7,0.4,1.4-0.4,2c0,1.8-0.7,3.5-1.1,5.3c-0.2,1-0.4,2-0.8,3c-1.1,2.5-2.4,4.9-3.6,7.3
		c-1,1.9-2.2,3.7-3.6,5.4c-1.4,1.8-2.9,3.7-4.6,5.3c-1.7,1.6-3.6,2.9-5.4,4.3c-3,2.4-6.3,4-9.7,5.5c-2.2,1-4.3,1.7-6.6,2.2
		c-1.3,0.2-2.8,0.5-4,1c-0.5,0.2-1.2,0-1.8,0c-0.1,0-0.4,0.2-0.5,0.4h-11c-0.1-0.1-0.4-0.4-0.5-0.4c-1.9,0.2-3.7-0.8-5.6-0.7
		c-1.8-1.1-4.1-1-5.9-2.2c-1.4-0.1-2.5-1.1-3.7-1.6c-1.3-0.5-2.5-1.1-3.7-1.8c-3-2-5.9-4.1-8.5-6.6c-1.1-1.1-2.2-2.3-3.1-3.5
		c-0.6-0.7-1.2-1.4-1.8-2.2c-1-1.3-2.2-2.6-2.9-4.2c-2.2-4-4.3-7.9-5.4-12.3c-0.2-1.1-0.5-2.3-0.7-3.4c-0.1-0.5-0.2-1-0.4-1.6
		s0-1.2-0.1-1.8c0,0-0.2-0.1-0.4-0.1V54c0.1,0,0.2-0.1,0.4-0.1c0-0.6,0-1.1,0.1-1.7s0.2-1.1,0.4-1.7c0.2-1.1,0.4-2.3,0.7-3.4
		c0.6-2,1.2-4.2,2.2-6.1c1.7-3.4,2.9-6.9,5.6-9.7c1.1-2.2,2.9-3.7,4.4-5.5c1-1.1,2.2-1.9,3.2-2.9c0.7-0.6,1.4-1.2,2.2-1.8
		c1.3-1,2.6-2.2,4.2-2.9c4-2,7.9-4.2,12.3-5.3c1.1-0.2,2.3-0.5,3.4-0.7c0.5-0.1,1-0.2,1.6-0.4c0.6-0.1,1.2,0,1.8-0.1
		c0,0,0.1-0.2,0.1-0.4L65.1,11.6L65.1,11.6z"
            ></path>
            <path
              d="M190.3,98.7H185v-3.1h4.9v-3.5H185v-2.5h5.3v-3.5h-9.6v16.2h9.6V98.7z M176.9,98.7h-7.2l7.1-9.9v-2.6h-12.3v3.6h6.8
		l-7.1,9.9v2.8h12.6L176.9,98.7L176.9,98.7z M160.3,86h-4.4v16.2h4.4V86z M143.3,89.3h0.8c1.6,0,2.3,0.6,2.3,1.7c0,1.3-0.7,2-2.3,2
		h-0.8V89.3L143.3,89.3z M144.4,96.3l3.5,5.9h4.9l-4.7-7.1c1.8-1.1,2.8-2.5,2.8-4.3c0-3.2-2.2-4.8-6.6-4.8H139v16.2h4.4v-5.9H144.4z
		 M127.9,89.6h1.1c1.2,0,1.8,0.6,1.8,1.7c0,0.6-0.2,1.2-0.6,1.6c-0.4,0.4-1,0.6-1.6,0.6h-0.7V89.6L127.9,89.6z M133.8,87.3
		c-1.1-0.8-2.5-1.3-4.6-1.3h-5.6v16.2h4.3v-5.4h1.2c1.9,0,3.5-0.5,4.6-1.4c1.1-1,1.6-2.4,1.6-4.2C135.3,89.5,134.8,88.3,133.8,87.3"
            ></path>
            <path
              d="M420.6,63.4h-4.8l5.4,10.1v6.2h4.4v-6.3l5.4-9.8h-4.8l-2.8,6L420.6,63.4z M412.6,63.4h-4.4v6h-5v-6h-4.4v16.2h4.4v-6.6h5
		v6.6h4.4V63.4z M387.6,66.8h1.1c1.2,0,1.8,0.6,1.8,1.7c0,0.6-0.2,1.2-0.6,1.6c-0.4,0.4-1,0.6-1.6,0.6h-0.8v-3.8H387.6z M393.5,64.7
		c-1.1-0.8-2.5-1.3-4.6-1.3h-5.6v16.2h4.4v-5.4h1.2c1.9,0,3.5-0.5,4.6-1.4s1.6-2.4,1.6-4.2C395.1,66.8,394.5,65.5,393.5,64.7
		 M370,72.9c0.7-2.5,1.1-4.2,1.3-5.1c0.2-0.8,0.4-1.4,0.4-1.9c0.1,0.4,0.2,1.1,0.5,2c0.2,1,0.5,1.7,0.6,2.3l0.7,2.6H370V72.9z
		 M380,79.5l-5.4-16.3h-5.9l-5.3,16.3h4.8l0.8-3h5.3l0.8,3C375.2,79.5,380,79.5,380,79.5z M351.8,66.6h0.8c1.6,0,2.3,0.6,2.3,1.7
		c0,1.3-0.7,2-2.3,2h-0.8V66.6L351.8,66.6z M353,73.7l3.5,5.9h4.9l-4.7-7.1c1.8-1.1,2.8-2.5,2.8-4.3c0-3.2-2.2-4.8-6.6-4.8h-5.3
		v16.2h4.4v-5.9H353L353,73.7z M335.9,73.4h2.9v2.5c-0.6,0.1-1.2,0.2-1.8,0.2c-1.2,0-2.2-0.4-2.8-1.2s-1-1.9-1-3.5
		c0-1.6,0.4-2.8,1.1-3.6c0.7-0.8,1.7-1.2,3-1.2c1.4,0,2.6,0.2,3.8,0.8l1.4-3.5c-0.7-0.2-1.4-0.6-2.4-0.7c-1-0.2-1.9-0.2-2.9-0.2
		c-2.6,0-4.8,0.7-6.2,2.2c-1.4,1.4-2.3,3.5-2.3,6.1c0,2.6,0.7,4.8,2,6.2c1.3,1.4,3.2,2.2,5.7,2.2c2.3,0,4.3-0.4,6.2-1v-8.7h-6.9
		L335.9,73.4L335.9,73.4z M317.3,66.7c1.1,0,1.9,0.4,2.4,1.2c0.6,0.7,0.8,1.9,0.8,3.6c0,1.6-0.2,2.8-0.8,3.6
		c-0.5,0.7-1.3,1.2-2.5,1.2c-2.2,0-3.2-1.6-3.2-4.7C314.1,68.3,315.2,66.7,317.3,66.7 M323.2,65.1c-1.3-1.4-3.2-2.2-5.9-2.2
		c-2.5,0-4.6,0.7-5.9,2.2s-2,3.5-2,6.2s0.7,4.8,2,6.2c1.3,1.4,3.4,2.2,5.9,2.2c2.6,0,4.6-0.7,5.9-2.2c1.3-1.4,2-3.5,2-6.2
		C325.3,68.6,324.5,66.6,323.2,65.1 M302.6,66.9h4v-3.6h-12.2v3.6h4v12.6h4.4L302.6,66.9L302.6,66.9z M283.6,66.7
		c1.1,0,1.9,0.4,2.4,1.2c0.6,0.7,0.8,1.9,0.8,3.6c0,1.6-0.2,2.8-0.8,3.6c-0.5,0.7-1.3,1.2-2.5,1.2c-2.2,0-3.2-1.6-3.2-4.7
		C280.2,68.3,281.3,66.7,283.6,66.7 M289.4,65.1c-1.3-1.4-3.2-2.2-5.9-2.2c-2.5,0-4.6,0.7-5.9,2.2c-1.3,1.4-2,3.5-2,6.2
		s0.7,4.8,2,6.2c1.3,1.4,3.4,2.2,5.9,2.2c2.6,0,4.6-0.7,5.9-2.2c1.3-1.4,2-3.5,2-6.2C291.4,68.6,290.8,66.6,289.4,65.1 M271.5,63.4
		H267v6h-5v-6h-4.4v16.2h4.4v-6.6h5v6.6h4.4V63.4z M246.6,66.8h1.1c1.2,0,1.8,0.6,1.8,1.7c0,0.6-0.2,1.2-0.6,1.6s-1,0.6-1.6,0.6
		h-0.8v-3.8H246.6z M252.3,64.7c-1.1-0.8-2.5-1.3-4.6-1.3h-5.6v16.2h4.4v-5.4h1.2c1.9,0,3.5-0.5,4.6-1.4s1.6-2.4,1.6-4.2
		C253.9,66.8,253.4,65.5,252.3,64.7 M230.9,63.4h-4v7.3c0,1,0,2.3,0.1,4h-0.1l-5.9-11.3h-5.7v16.2h3.8v-7.3c0-1-0.1-2.3-0.2-4.1h0.1
		l5.9,11.4h5.7L230.9,63.4L230.9,63.4z M202.4,72.9c0.7-2.5,1.1-4.2,1.3-5.1c0.2-0.8,0.4-1.4,0.4-1.9c0.1,0.4,0.2,1.1,0.5,2
		c0.2,1,0.5,1.7,0.6,2.3l0.7,2.6h-3.5V72.9z M212.3,79.5l-5.4-16.3h-5.9l-5.3,16.3h4.8l0.8-3h5.3l0.8,3
		C207.5,79.5,212.3,79.5,212.3,79.5z M190.4,66.9c0.6,0.2,1.2,0.5,1.8,0.7l1.3-3.5c-1.6-0.7-3.2-1.2-5-1.2c-1.6,0-3,0.4-4.2,1.1
		c-1.2,0.7-2,1.7-2.8,2.9c-0.6,1.3-1,2.8-1,4.4c0,2.6,0.6,4.8,1.9,6.1c1.3,1.4,3.2,2.2,5.6,2.2c1.7,0,3.2-0.4,4.6-1v-3.6
		c-0.7,0.2-1.3,0.5-2,0.7c-0.7,0.2-1.3,0.2-2,0.2c-2.4,0-3.6-1.6-3.6-4.7c0-1.6,0.2-2.6,0.8-3.5c0.6-0.8,1.4-1.3,2.4-1.3
		C189.1,66.7,189.8,66.8,190.4,66.9 M176.4,63.4H172v16.2h4.4V63.4z M159.4,66.6h0.8c1.6,0,2.3,0.6,2.3,1.7c0,1.3-0.7,2-2.3,2h-0.8
		V66.6L159.4,66.6z M160.6,73.7l3.5,5.9h4.9l-4.7-7.1c1.8-1.1,2.8-2.5,2.8-4.3c0-3.2-2.2-4.8-6.6-4.8h-5.3v16.2h4.4v-5.9H160.6
		L160.6,73.7z M145.9,73.4h4.9v-3.5h-4.9v-3.1h5.3v-3.5h-9.6v16.2h4.3V73.4z M128.4,72.9c0.7-2.5,1.1-4.2,1.3-5.1
		c0.2-0.8,0.4-1.4,0.4-1.9c0.1,0.4,0.2,1.1,0.5,2c0.2,1,0.5,1.7,0.6,2.3l0.7,2.6h-3.5V72.9z M138.3,79.5l-5.4-16.3h-5.9l-5.3,16.3
		h4.8l0.8-3h5.3l0.8,3C133.5,79.5,138.3,79.5,138.3,79.5z"
            ></path>
            <path
              d="M372.3,40.6h-4.8l5.3,10.1v6.2h4.4v-6.3l5.3-9.8h-4.8l-2.8,6L372.3,40.6z M357.6,44h0.8c1.6,0,2.3,0.6,2.3,1.7
		c0,1.3-0.7,2-2.3,2h-0.8V44L357.6,44z M358.7,50.9l3.5,5.9h4.9l-4.7-7.1c1.8-1.1,2.8-2.5,2.8-4.3c0-3.2-2.2-4.8-6.6-4.8h-5.3v16.2
		h4.4v-5.9C357.7,50.9,358.7,50.9,358.7,50.9z M340,50.2c0.7-2.5,1.1-4.2,1.3-5.1c0.2-0.8,0.4-1.4,0.4-1.9c0.1,0.4,0.2,1.1,0.5,2
		c0.2,1,0.5,1.7,0.6,2.3l0.7,2.6L340,50.2L340,50.2z M349.9,56.8l-5.3-16.2h-5.9l-5.3,16.3h4.8l0.8-3h5.3l0.8,3h4.7V56.8z M321.8,44
		h0.8c1.6,0,2.3,0.6,2.3,1.7c0,1.3-0.7,2-2.3,2h-0.8V44L321.8,44z M323,50.9l3.5,5.9h4.9l-4.7-7.1c1.8-1.1,2.8-2.5,2.8-4.3
		c0-3.2-2.2-4.8-6.6-4.8h-5.3v16.2h4.4v-5.9C322,50.9,323,50.9,323,50.9z M305.4,44c1.1,0,1.9,0.4,2.4,1.2c0.6,0.7,0.8,1.9,0.8,3.6
		c0,1.6-0.2,2.8-0.8,3.6c-0.5,0.7-1.3,1.2-2.5,1.2c-2.2,0-3.2-1.6-3.2-4.7C302,45.5,303.2,44,305.4,44 M311.2,42.5
		c-1.3-1.4-3.2-2.2-5.9-2.2c-2.5,0-4.6,0.7-5.9,2.2c-1.3,1.4-2,3.5-2,6.2s0.7,4.8,2,6.2c1.3,1.4,3.4,2.2,5.9,2.2
		c2.6,0,4.6-0.7,5.9-2.2c1.3-1.4,2-3.5,2-6.2C313.2,46,312.6,44,311.2,42.5 M286.8,44.2h1.1c1.2,0,1.8,0.6,1.8,1.7
		c0,0.6-0.2,1.2-0.6,1.6s-1,0.6-1.6,0.6h-0.8v-3.8H286.8z M292.6,41.9c-1.1-0.8-2.5-1.3-4.6-1.3h-5.6v16.2h4.4v-5.4h1.2
		c1.9,0,3.5-0.5,4.6-1.4c1.1-1,1.6-2.4,1.6-4.2C294.1,44.1,293.6,42.9,292.6,41.9 M270.4,56.8l3.2-11.6h0.1
		c-0.1,1.8-0.1,2.9-0.1,3.4s0,0.8,0,1.2v7.1h4.1V40.6h-5.9l-3.4,11.5h-0.1L265,40.6h-5.9v16.2h3.8v-7.1c0-1.1-0.1-2.6-0.2-4.7h0.1
		l3.4,11.6L270.4,56.8L270.4,56.8z M254.7,53.3h-5.3v-3.1h4.9v-3.5h-4.9v-2.5h5.3v-3.5h-9.6v16.2h9.6V53.3z M237.6,44.2h4v-3.6
		h-12.3v3.6h4v12.6h4.4V44.2L237.6,44.2z M225.7,40.6h-4v7.3c0,1,0,2.3,0.1,4h-0.1l-5.9-11.3h-5.7v16.2h3.8v-7.3
		c0-1-0.1-2.3-0.2-4.1h0.1l5.9,11.4h5.7L225.7,40.6L225.7,40.6z M198.3,44c1.1,0,1.9,0.4,2.4,1.2c0.6,0.7,0.8,1.9,0.8,3.6
		c0,1.6-0.2,2.8-0.8,3.6c-0.6,0.8-1.3,1.2-2.5,1.2c-2.2,0-3.2-1.6-3.2-4.7C195,45.5,196,44,198.3,44 M204.2,42.5
		c-1.3-1.4-3.2-2.2-5.9-2.2c-2.5,0-4.6,0.7-5.9,2.2c-1.3,1.4-2,3.5-2,6.2s0.7,4.8,2,6.2c1.3,1.4,3.4,2.2,5.9,2.2
		c2.6,0,4.6-0.7,5.9-2.2c1.3-1.4,2-3.5,2-6.2C206.1,46,205.5,44,204.2,42.5 M184.4,44.3c0.6,0.2,1.2,0.5,1.8,0.7l1.3-3.5
		c-1.6-0.7-3.2-1.2-5-1.2c-1.6,0-3,0.4-4.2,1.1c-1.2,0.7-2,1.7-2.8,2.9c-0.6,1.3-1,2.8-1,4.4c0,2.6,0.6,4.8,1.9,6.1
		c1.3,1.4,3.2,2.2,5.6,2.2c1.7,0,3.2-0.2,4.6-1v-3.7c-0.7,0.2-1.3,0.5-2,0.7c-0.7,0.2-1.3,0.4-2,0.4c-2.4,0-3.6-1.6-3.6-4.7
		c0-1.6,0.2-2.6,0.8-3.5c0.6-0.8,1.4-1.3,2.4-1.3C183.2,44,183.8,44.1,184.4,44.3 M166.5,53.3h-5.3v-3.1h4.9v-3.5h-4.9v-2.5h5.3
		v-3.5h-9.6v16.2h9.6V53.3z M152.1,40.6h-4.4v6h-5v-6h-4.4v16.2h4.4v-6.6h5v6.6h4.4V40.6z M130.6,44.2h4v-3.6h-12.2v3.6h4v12.6h4.4
		V44.2H130.6z"
            ></path>
            <path
              d="M244.1,30.5h-5.3v-3.1h4.9V24h-4.9v-2.5h5.3V18h-9.6v16.2h9.6V30.5L244.1,30.5z M230.6,30.5h-7.2l7.1-9.9V18h-12.3v3.6h6.8
		l-7.1,9.9v2.8h12.6v-3.7H230.6z M214.1,18h-4.4v16.2h4.4V18z M197.1,21.2h0.8c1.6,0,2.3,0.6,2.3,1.7c0,1.3-0.7,2-2.3,2h-0.8V21.2z
		 M198.2,28.3l3.5,5.9h4.9l-4.7-7.1c1.8-1.1,2.8-2.5,2.8-4.3c0-3.2-2.2-4.8-6.6-4.8h-5.3v16.2h4.4v-5.9H198.2z M181.7,21.4h1.1
		c1.2,0,1.8,0.6,1.8,1.7c0,0.6-0.2,1.2-0.6,1.6c-0.4,0.4-1,0.6-1.6,0.6h-0.8v-3.8H181.7z M187.5,19.3c-1.1-0.8-2.5-1.3-4.6-1.3h-5.6
		v16.2h4.4v-5.4h1.2c1.9,0,3.5-0.5,4.6-1.4c1.1-1,1.6-2.4,1.6-4.2C189.1,21.4,188.5,20.1,187.5,19.3 M162.3,21.4h1.1
		c1.2,0,1.8,0.6,1.8,1.7c0,0.6-0.2,1.2-0.6,1.6c-0.4,0.4-1,0.6-1.6,0.6h-0.8v-3.8H162.3z M168,19.3c-1.1-0.8-2.5-1.3-4.6-1.3h-5.6
		v16.2h4.4v-5.4h1.2c1.9,0,3.5-0.5,4.6-1.4c1.1-1,1.6-2.4,1.6-4.2C169.6,21.4,169.1,20.1,168,19.3 M144.7,27.5
		c0.7-2.5,1.1-4.2,1.3-5.1c0.2-0.8,0.4-1.4,0.4-1.9c0.1,0.4,0.2,1.1,0.5,2c0.2,1,0.5,1.7,0.6,2.3l0.7,2.6h-3.5V27.5z M154.6,34.1
		l-5.4-16.3h-5.7l-5.3,16.3h4.8l0.8-3h5.3l0.8,3H154.6z M132.7,21.6c0.6,0.2,1.2,0.5,1.8,0.7l1.3-3.5c-1.6-0.7-3.2-1.2-5-1.2
		c-1.6,0-3,0.4-4.2,1.1s-2,1.7-2.8,2.9c-0.6,1.3-1,2.8-1,4.4c0,2.6,0.6,4.8,1.9,6.1c1.3,1.4,3.2,2.2,5.6,2.2c1.7,0,3.2-0.4,4.6-1
		v-3.7c-0.7,0.2-1.3,0.5-2,0.7c-0.7,0.2-1.3,0.4-2,0.4c-2.4,0-3.6-1.6-3.6-4.7c0-1.6,0.2-2.6,0.8-3.5c0.6-0.8,1.4-1.3,2.4-1.3
		C131.5,21.3,132.1,21.4,132.7,21.6"
            ></path>
          </g>
        </svg>
      </router-link>

      <!-- .col -->
      <div class="custom-nav-links d-none d-md-block">
        <base-icon name="bar-chart" v-if="isAdmin" :height="18" :strokeWidth="2">
          <router-link class="pr-4" :to="{ name: 'dashboard' }">Admin Dashboard</router-link>
        </base-icon>
        <base-icon name="grid" :height="18" :strokeWidth="2">
          <router-link class="pr-4" :to="{ name: 'judging-entries' }">Entry list</router-link>
        </base-icon>
        <base-icon name="custom-star" v-b-modal.progressModal :height="18" :strokeWidth="2">
          <b-link class="pr-4">Progress</b-link>
        </base-icon>
        <base-icon name="log-out" :height="18" :strokeWidth="2">
          <a href="#" @click="signOut()">Sign out</a>
        </base-icon>
      </div>
      <!-- .col -->
    </div>
    <!-- row -->
    <b-modal
      id="progressModal"
      ref="pModal"
      title="Review progress"
      size="lg"
      hide-footer
      hide-header
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid"
        viewBox="0 0 766 545"
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="198.48"
            y1="659.59"
            x2="567.52"
            y2="20.41"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#e6e6e6"></stop>
            <stop offset="1" stop-color="#ccc"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-2"
            x1="383"
            y1="135"
            x2="383"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#f2f2f2"></stop>
            <stop offset="1" stop-color="#fff"></stop>
          </linearGradient>
        </defs>
        <title>modal</title>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_3" data-name="Layer 3">
            <rect y="135" width="766" height="410" fill="url(#linear-gradient)"></rect>
            <g>
              <rect width="766" height="135" fill="url(#linear-gradient-2)"></rect>
              <text
                transform="translate(53 92)"
                font-size="22"
              >Hi {{scores[0].name[0]}}, here's your stats</text>
            </g>
            <g>
              <g>
                <rect x="50" y="185" width="210" height="147" fill="#fff"></rect>
                <text transform="translate(61 206)" font-size="17" fill="#4d4d4d">unseen</text>
              </g>
              <g>
                <polygon
                  points="195 225 203 265 195 305 155 313 115 305 108 265 115 225 155 218 195 225"
                ></polygon>
                <text
                  transform="translate(155 272)"
                  font-size="25"
                  fill="#fff"
                  font-weight="700"
                  text-anchor="middle"
                >{{unseen()}}</text>
              </g>
            </g>
            <g>
              <g>
                <rect x="278" y="185" width="210" height="147" fill="#fff"></rect>
                <text transform="translate(290 206)" font-size="17" fill="#4d4d4d">seen</text>
              </g>
              <g>
                <g>
                  <rect x="346" y="229" width="74" height="73.54"></rect>
                  <rect
                    x="346"
                    y="229"
                    width="74"
                    height="73.54"
                    transform="translate(-76 349) rotate(-45)"
                  ></rect>
                </g>
                <text
                  transform="translate(384 274)"
                  font-size="25"
                  fill="#fff"
                  font-weight="700"
                  text-anchor="middle"
                >{{seen}}</text>
              </g>
            </g>
            <g>
              <g>
                <rect x="506" y="185" width="210" height="147" fill="#fff"></rect>
                <text transform="translate(518 206)" font-size="17" fill="#4d4d4d">started scoring</text>
              </g>
              <g>
                <g>
                  <circle cx="587" cy="242" r="17"></circle>
                  <circle cx="636" cy="242" r="17"></circle>
                  <circle cx="587" cy="292" r="17"></circle>
                  <circle cx="636" cy="292" r="17"></circle>
                  <rect
                    x="575"
                    y="230"
                    width="73"
                    height="72.83"
                    transform="translate(-9 510) rotate(-45)"
                  ></rect>
                </g>
                <text
                  transform="translate(613 274)"
                  font-size="25"
                  fill="#fff"
                  font-weight="700"
                  text-anchor="middle"
                >{{startedScoring}}</text>
              </g>
            </g>
            <g>
              <g>
                <rect x="50" y="348" width="210" height="147" fill="#fff"></rect>
                <text transform="translate(61 372)" font-size="17" fill="#4d4d4d">zero</text>
              </g>
              <g>
                <polygon
                  points="174 380 136 380 110 407 110 444 136 470 174 470 200 444 200 407 174 380"
                ></polygon>
                <text
                  transform="translate(154 433)"
                  font-size="25"
                  fill="#fff"
                  font-weight="700"
                  text-anchor="middle"
                >{{zero}}</text>
              </g>
            </g>
            <g>
              <g>
                <rect x="278" y="348" width="210" height="147" fill="#fff"></rect>
                <text transform="translate(290 372)" font-size="17" fill="#4d4d4d">scored</text>
              </g>
              <g>
                <circle cx="383" cy="425" r="47"></circle>
                <text
                  transform="translate(383 433)"
                  font-size="25"
                  fill="#fff"
                  font-weight="700"
                  text-anchor="middle"
                >{{scored}}</text>
              </g>
            </g>
            <g>
              <g>
                <rect x="506" y="348" width="210" height="147" fill="#fff"></rect>
                <text transform="translate(518 372)" font-size="17" fill="#4d4d4d">loved</text>
              </g>
              <g>
                <g>
                  <rect
                    x="580"
                    y="403"
                    width="62"
                    height="62.13"
                    transform="translate(-128 559) rotate(-45)"
                  ></rect>
                  <circle cx="589" cy="412" r="31"></circle>
                  <circle cx="633" cy="412" r="31"></circle>
                </g>
                <text
                  transform="translate(610 433)"
                  font-size="25"
                  fill="#fff"
                  text-anchor="middle"
                  font-weight="700"
                >{{loved}}</text>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <div id="close-button-container">
        <button type="button" class="close" aria-label="Close" @click="closeProgressModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  components: {},
  methods: {
    signOut() {
      this.$router.push({
        name: 'sign-in'
      })
      this.$store.dispatch('auth/signOut')
    },
    unseen() {
      return this.allEntryArray.length - this.seen
    },
    /* firstName() {
      const nameArray = this.name.split(' ')
      return nameArray[0]
    },*/
    closeProgressModal() {
      this.$refs.pModal.hide()
    }
  },
  computed: {
    ...mapState({
      isAdmin: state => state.judging.admin
    }),
    ...mapGetters({
      // entries: 'review/filteredEntries',
      allEntryArray: 'judging/allEntryArray',
      seen: 'judging/seen',
      startedScoring: 'judging/startedScoring',
      zero: 'judging/zero',
      scored: 'judging/scored',
      loved: 'judging/loved',
      firstName: 'judging/firstName',
      scores: 'judging/scores'
    })
  },
  mounted() {
    // this.$refs.progressModal.show()
    // this.$nextTick(() => {
    if (!this.$store.state.judging.progressModal) {
      this.$refs.pModal.show()
    }
    this.$root.$on('bv::modal::hide', (bvEvent, progressModal) => {
      console.log('Modal is about to be hidden', bvEvent, progressModal)
      this.$store.commit('judging/UPDATE_PROGRESS_MODAL')
    })
    //  })
  }
}
</script>

<style lang="scss">
#progressModal svg {
  max-width: none;
}
.custom-nav-links a {
  color: black;
}

#logo {
  width: 100%;
  max-width: 440px;
  padding-top: 1em;
  padding-bottom: 1em;
  cursor: pointer;
}
.custom-nav-links a:hover {
  color: black;
  opacity: 0.9;
}

#close-button-container {
  position: absolute;
  top: 0.5em;
  right: 0.8em;
}

@media (min-width: 768px) {
  #logo {
    width: 440px;
  }
}

#progressModal .modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  max-width: none !important;
}

@media (min-width: 992px) {
  #progressModal .modal-dialog {
    max-width: 800px !important;
    margin: 1.75rem auto;
  }
}
</style>
